(function () {
  const PX_PER_CM = 16;
  const controllers = new WeakMap();

  // immediate = true  → grow right away (first load)
  // immediate = false → shrink first, then grow (repeat cycle)
  const animateCard = (card, immediate) => {
    const block = card.querySelector('[data-confidence-block]');
    if (!block) return;

    if (immediate) {
      block.style.height = '';
      card.classList.add('is-active');
    } else {
      card.classList.remove('is-active');
      void block.offsetHeight; // force reflow so transition restarts
      setTimeout(() => {
        block.style.height = '';
        card.classList.add('is-active');
      }, 1600); // buffer after 1.5s CSS transition
    }
  };

  const runCycle = (cards, immediate) => {
    if (!immediate) {
      cards.forEach((card) => {
        const block = card.querySelector('[data-confidence-block]');
        if (!block) return;
        card.classList.remove('is-active');
        void block.offsetHeight;
      });
    }

    cards.forEach((card, index) => {
      const delay = immediate ? index * 1700 : 1600 + index * 1700;
      window.setTimeout(() => animateCard(card, true), delay);
    });
  };

  const init = (section) => {
    if (controllers.has(section)) return;

    const cards = Array.from(section.querySelectorAll('[data-boost-cm]'));

    // Pre-set CSS vars so blocks know how tall to grow
    cards.forEach((card) => {
      const cm = parseFloat(card.dataset.boostCm) || 0;
      card.style.setProperty('--boost-height', `${Math.round(cm * PX_PER_CM)}px`);
    });

    let intervalId;
    let timeoutIds = [];

    const clearTimers = () => {
      window.clearInterval(intervalId);
      timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
      intervalId = undefined;
      timeoutIds = [];
    };

    const start = () => {
      if (intervalId !== undefined) return;
      runCycle(cards, true);
      intervalId = window.setInterval(() => runCycle(cards, false), 6500);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          start();
        } else {
          clearTimers();
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(section);

    controllers.set(section, { clearTimers, observer });
  };

  const initAll = () =>
    document.querySelectorAll('[data-height-confidence]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
